import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import HeaderAuth from "../components/HeaderAuth";

const RegisterExpert = () => {
    const [nom, setNom] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleRegister = (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            setError("Les mots de passe ne correspondent pas !");
            return;
        }
        console.log("Inscription réussie :", { nom, email });
        navigate("/dashboard-expert");
    };

    return (
        <>
            <HeaderAuth />
            <section className="register-page">
                <div className="register-container">
                    <div className="logo-container">
                        <img src="../assets/images/cinef.png" alt="Logo" className="logo" />
                    </div>

                    <h2 className="text-center" style={{ color: "#008A44", fontWeight: "bold" }}>
                        Créer un compte
                    </h2>
                    <p className="text-center">Rejoignez-nous dès maintenant !</p>

                    <form onSubmit={handleRegister}>
                        <div className="form-group">
                            <label>Nom complet</label>
                            <input
                                type="text"
                                className="form-control"
                                value={nom}
                                onChange={(e) => setNom(e.target.value)}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label>Email *</label>
                            <input
                                type="email"
                                className="form-control"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label>Mot de passe</label>
                            <input
                                type="password"
                                className="form-control"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label>Confirmez le mot de passe</label>
                            <input
                                type="password"
                                className="form-control"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                required
                            />
                        </div>

                        <div className="form-options">
                            <label>
                                <input type="checkbox" required /> J'accepte les{" "}
                                <Link to="/terms" className="link">
                                    Conditions d'utilisation & Politique de confidentialité
                                </Link>
                            </label>
                        </div>

                        {error && <p className="text-danger text-center">{error}</p>}

                        <button type="submit" className="btn btn-register">S'inscrire</button>
                    </form>

                    <p className="social-text">Ou inscrivez-vous avec :</p>
                    <div className="social-login">
                        <button className="btn btn-social">Google</button>
                        <button className="btn btn-social">Facebook</button>
                    </div>

                    <p className="text-center mt-3">
                        Déjà un compte ?{" "}
                        <Link to="/loginexpert" className="link">
                            Connectez-vous ici
                        </Link>
                    </p>
                </div>

                <style>{`
        .register-page {
          display: flex;
          justify-content: center;
          align-items: flex-start;
          min-height: 100vh;
          overflow-y: auto;
          padding: 40px 0;
          background: linear-gradient(to bottom, #f9f9f9 50%, white 100%);
        }

        .register-container {
          width: 400px;
          background: white;
          padding: 35px;
          border-radius: 10px;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
          text-align: center;
        }

        .logo-container {
          display: flex;
          justify-content: center;
          margin-bottom: 20px;
        }

        .logo {
          width: 90px;
          height: auto;
        }

        .form-group {
          margin-bottom: 15px;
          text-align: left;
        }

        .form-group label {
          font-weight: bold;
          margin-bottom: 5px;
          display: block;
        }

        .form-control {
          width: 100%;
          padding: 12px;
          border: 1px solid #ddd;
          border-radius: 5px;
        }

        .form-options {
          text-align: left;
          font-size: 14px;
          margin-bottom: 15px;
        }

        .btn-register {
          width: 100%;
          padding: 12px;
          font-size: 18px;
          font-weight: bold;
          background: linear-gradient(45deg, #db4437, #008a44);
          color: white;
          border: none;
          border-radius: 5px;
          cursor: pointer;
          transition: 0.3s;
        }

        .btn-register:hover {
          opacity: 0.9;
        }

        .social-text {
          margin-top: 15px;
          font-size: 14px;
          color: #666;
        }

        .social-login {
          display: flex;
          flex-direction: column;
          gap: 10px;
        }

        .btn-social {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          padding: 12px;
          width: 100%;
          font-size: 16px;
          font-weight: bold;
          background: #eee;
          color: #333;
          border: 1px solid #ddd;
          border-radius: 5px;
          cursor: pointer;
          transition: 0.3s;
        }

        .btn-social:hover {
          background: #ddd;
        }

        .link {
          color: #6c63ff;
          text-decoration: none;
          font-weight: bold;
        }

        .link:hover {
          text-decoration: underline;
        }

        @media (max-width: 500px) {
          .register-container {
            width: 90%;
          }
        }
      `}</style>
            </section>
        </>
    );
};

export default RegisterExpert;
